import React from 'react';
import { UserDetailsForm } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/UserDetailsForm';
import { useUserData } from '@/components/pages/SettingsPage/MainContent/shared/useUserData';
import { Skeleton } from '@/components/ui/skeleton';
import { UserPreferencesRef } from '@/components/pages/SettingsPage/MainContent/UserManagement/UserPreferences';

interface UserDetailsProps {
  ref: UserPreferencesRef;
}

export const UserDetails = React.forwardRef<UserPreferencesRef, UserDetailsProps>((props, ref) => {
  const { userData, isLoadingUserData } = useUserData();

  if (isLoadingUserData) {
    return <Skeleton className="h-[calc(100vh-15.3rem)]" />;
  }

  return <UserDetailsForm userData={userData} isLoadingUserData={isLoadingUserData} ref={ref} />;
});

UserDetails.displayName = 'UserDetails';
